import AuthorizationWrapper from "../AuthorizationWrapper";
import { Grid, MenuItem, Select, Typography } from "@material-ui/core";
import React from "react";
import withIntl from "../../utils/withIntl";

export const languages = ["english", "dutch", "german", "french", "spanish", "chinese"];

function LanguagesSetting(props) {
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <Grid container alignItems={"center"} spacing={1}>
            <Grid item xs={4}>
              <Select
                style={{ width: "95%" }}
                multiple
                disabled={!write}
                value={props.setting.getValues(props.setting.value)}
                onChange={(e) => props.onChange(e.target.value)}
              >
                {languages.map((language) => {
                  return <MenuItem value={language}>{props.intl.formatMessage({ id: language })}</MenuItem>;
                })}
              </Select>
            </Grid>
            <Grid item xs={8}>
              <Typography>{props.label}</Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default withIntl(LanguagesSetting);
